<template>
  <div class="photography-collaborators-content" id="identidade-visual-fotografia-colaboradores" data-search-anchor>
    <div class="title-photography-collaborators-wrapper">
      <h1 class="photography-collaborators-title-span">{{ photographyCollaboratorsTitleSpan }}</h1>
      <h1 class="photography-collaborators-title">{{ photographyCollaboratorsTitle }}</h1>
    </div>
    <div class="description-photography-collaborators-wrapper">
      <div>
        <div class="photography-collaborators-icon-wrapper">
          <IconCheck />
          <p class="photography-collaborators-description">
            {{ photographyCollaboratorsDescription1 }}
          </p>
        </div>

        <div class="photography-collaborators-icon-wrapper">
          <IconCheck />
          <p class="photography-collaborators-description">
            {{ photographyCollaboratorsDescription2 }}
          </p>
        </div>
      </div>

      <div>
        <div class="photography-collaborators-icon-wrapper">
          <IconCheck />
          <p class="photography-collaborators-description">
            {{ photographyCollaboratorsDescription3 }}
          </p>
        </div>

        <div class="photography-collaborators-icon-wrapper">
          <IconCheck />
          <p class="photography-collaborators-description">
            {{ photographyCollaboratorsDescription4 }}
          </p>
        </div>
      </div>
    </div>

    <div class="expandable-image-collaborators">
      <PhotographyExpandableImage :src="photographyCollaboratorsImageSrc1" alt="" />
      <PhotographyExpandableImage :src="photographyCollaboratorsImageSrc2" alt="" />
      <PhotographyExpandableImage :src="photographyCollaboratorsImageSrc3" alt="" />
      <PhotographyExpandableImage :src="photographyCollaboratorsImageSrc4" alt="" />
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PhotographyPageMixin from '@/mixins/photography-page-mixin'
import { PhotographyPageStore } from '@/store/visual-identity-page/photography-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import PhotographyExpandableImage from './PhotographyExpandableImage.vue'
import IconCheck from '@/assets/icons/IconCheck.vue'

@Component({
  components: { IconCheck, PhotographyExpandableImage }
})
export default class PhotographyCollaboratorsSection extends Mixins(PhotographyPageMixin) {
  photographyPageStore: PageStoreContract = getModule(PhotographyPageStore, this.$store)

  get photographyCollaboratorsTitleSpan(): string {
    return this.getElementTitle(6, 0)
  }

  get photographyCollaboratorsTitle(): string {
    return this.getElementText(6, 0)
  }

  get photographyCollaboratorsDescription1(): string {
    return this.getElementText(6, 1)
  }

  get photographyCollaboratorsDescription2(): string {
    return this.getElementText(6, 2)
  }

  get photographyCollaboratorsDescription3(): string {
    return this.getElementText(6, 3)
  }

  get photographyCollaboratorsDescription4(): string {
    return this.getElementText(6, 4)
  }

  get photographyCollaboratorsImageSrc1(): string {
    return this.getElementMedia(6, 5)
  }

  get photographyCollaboratorsImageSrc2(): string {
    return this.getElementMedia(6, 6)
  }

  get photographyCollaboratorsImageSrc3(): string {
    return this.getElementMedia(6, 7)
  }

  get photographyCollaboratorsImageSrc4(): string {
    return this.getElementMedia(6, 8)
  }

  async getPhotographyPage(): Promise<void> {
    await this.photographyPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.photographyPageStore.isLoading) {
      await this.getPhotographyPage()
    }
  }
}
</script>

<style lang="scss">
.photography-collaborators-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
  margin-bottom: 2rem;
}

.title-photography-collaborators-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.photography-collaborators-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.photography-collaborators-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-photography-collaborators-wrapper {
  position: relative;
  
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1rem;
}

.photography-collaborators-icon-wrapper{
  display: flex;
  align-items: center;  
}

.photography-collaborators-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 378px;  
}

.expandable-image-collaborators {
  display: grid;
  grid-template-columns: 1fr 1fr;  
  gap: 15px;
}
</style>
